export const InstitutionName = "Southern Delta University Ozoro";
export const CURRENT_SESSION = "2026/2027";
export const SCHOOL_ID = 2;

export const SpecialDepartmentsForApplication = [
    "Agricultural Economics",
    "Animal Production",
    "Crop Science",
    "Soil Science",
    "Urban and Regional Planning",
    "Animal and Environmental Biology",
    "Chemistry",
    "Environmental Management and Toxicology",
    "Geology",
    "Industrial Chemistry",
    "Mathematics",
    "Physics",
    "Petroleum Chemistry",
    "Plant Science and Biotechnology",
    "Statistics",
    "Agricultural Engineering",
    "Quantity Survey",
    "English and Literary Studies",
    "History and International Relations",
    "LAW"
]

export const APPLICATION_PAYMENT_CATEGORIES = {
    WEEKEND: "WKD_APPLICATION_FEE",
    WEEKEND_DE: "WKD_DE_APPLICATION_FEE",
    CONVERSION: "HND_CONVERSION_APPLICATION_FEE",
    UNDER_GRAD: "UNDERGRAD_APPLICATION_FEE",
    DIPLOMA: "DIPLOMA_APPLICATION_FEE",
    PRE_DEGREE: "PRE_DEGREE_APPLICATION_FEE",
}

export const PROGRAMME_TYPES = {
    WEEKEND: "weekend",
    CONVERSION: "conversion",
    DIPLOMA: "diploma",
    PRE_DEGREE: "pre-degree",
}

export const HOLIDAY_STORAGE_KEY = "ceed_holiday_registration";

export const X_SCHOOL_CODE = "ozoro";

export const currencyFormatter = (value) => {
  return Number(value)?.toLocaleString("en-NG", { style: "currency", currency: "NGN" });
};

export const nextOfKinRelationship = [
  ("FATHER", "Father"),
  ("MOTHER", "Mother"),
  ("BROTHER", "Brother"),
  ("SISTER", "Sister"),
  ("GUARDIAN", "Guardian"),
  ("OTHER", "Other"),
  ("RELATIVE", "Relative"),
];

export const errorProp = {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
  };

  export const warnProp = {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
  };

  export const successProp = {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
  };